// Imports
import { withStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, Card, CardMedia, CardContent, CardActions, IconButton, FormControlLabel, ToggleButtonGroup, ToggleButton, Box } from "@mui/material";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import DownloadIcon from '@mui/icons-material/Download';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
// UI Imports
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import dayjs from 'dayjs';
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// App Imports
import { messageShow } from "../../common/api/actions";
import EmptyMessage from "../../common/EmptyMessage";
import Image from "../../common/Image";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { publishToggle, remove } from "../api/actions/mutation";
import { listParent, categoryCollection } from "../api/actions/query";
import routes, { getImageSource } from "../api/routes";
import styles from "./styles";
import { detail } from "../../setting/api/actions/query";
import { checkPermission } from "../../common/Sidebar/checkPermission";

// Component
class List extends PureComponent {
  state = {
    viewMode: null,
    permissions: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
  };
  componentDidMount() {
    this.refresh();
    this.verifyPermissions();
    this.fetchSettings();
  }
  verifyPermissions = async () => {
    const modulePermission = await checkPermission("store", "category");
    this.setState({permissions:{canEdit:modulePermission.canEdit,canDelete: modulePermission.canDelete,canCreate: modulePermission.canCreate,canView: modulePermission.canView}});
  };
  
   fetchSettings = async () => {
    const { detail } = this.props;
    try {
      const { data } = await detail({ vendorId: '' });
      if (data.success && data.data) {
        const viewMode = data.data.viewMode || 'grid';
        this.setState({ viewMode });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };

  refresh = () => {
    const { listParent } = this.props;

    listParent();
  };

  onDelete = async (categoryId) => {
    let check = window.confirm(
      "Are you sure you want to delete this category?"
    );

    if (check) {
      const { remove, messageShow } = this.props;

      try {
        const { data } = await remove({ categoryId });

        messageShow(data.message);

        if (data.success) {
          this.refresh();
        }
      } catch (error) {
        messageShow("Some error occurred. Please try again.");
      }
    }
  };

  onPublishToggle = async (event, categoryId) => {
    const isPublished = event.target.checked;

    let check = window.confirm(
      `Are you sure you want to ${
        isPublished ? "publish" : "unpublish"
      } this category?`
    );

    if (check) {
      const { publishToggle, messageShow } = this.props;

      try {
        const { data } = await publishToggle({ categoryId, isPublished });

        messageShow(data.message);

        if (data.success) {
          this.refresh();
        }
      } catch (error) {
        messageShow("Some error occurred. Please try again.");
      }
    }
  };

  exportToCSV = async () => {
    const { categoryCollection, messageShow } = this.props;
    try {
      messageShow("Generating categories export report...");
      const { data } = await categoryCollection();

      if (data.success && data.data) {
        messageShow("Categories report generated successfully!");
        window.open(data.data, "_blank");
      } else {
        messageShow(data.message || "No categories found for export.");
      }
    } catch (err) {
      console.error("Export error:", err);
      messageShow("There was some error. Please try again.");
    }
  };

  render() {
    const {
      categoriesParent: { isLoading, list },
      classes,
    } = this.props;
    const {permissions, viewMode} = this.state
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Categories
          </Typography>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newView) => {
              if (newView !== null) this.setState({ viewMode: newView });
            }}
            size="small"
            sx={{ marginRight: 2 }}
          >
            <Tooltip title="Grid View" arrow>
              <ToggleButton value="grid">
                <ViewModuleIcon />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="List View" arrow>
              <ToggleButton value="list">
                <ViewListIcon />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
          {permissions.canCreate ? (
            <Link to={routes.categoryCreate.path}>
              <Tooltip title="Create Category" arrow>
                <Button
                  size='big'
                  color="primary"
                  startIcon={<AddIcon />}
                />
              </Tooltip>
            </Link>
          ) : (
            <Button
              size='big'
              color="primary"
              startIcon={<AddIcon />}
              disabled
            />
          )}

          {/* Bulk Create Category Button */}
          {permissions.canCreate ? (
            <Link to={routes.categoryBulkCreate.path}>
              <Tooltip title="Bulk Create Categories" arrow>
                <Box position="relative" display="inline-flex" style={{ marginLeft: 6, marginRight: 6 }}>
                  <FileCopyOutlinedIcon
                    style={{
                      fontSize: 30,
                      color: '#00A4EF',
                    }}
                  />
                  <AddIcon
                    style={{
                      fontSize: 18,
                      position: 'absolute',
                      top: '60%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#00A4EF',
                    }}
                  />
                </Box>
              </Tooltip>
            </Link>
          ) : (
            <Tooltip title="Bulk Create Categories" arrow>
              <Box position="relative" display="inline-flex" style={{ marginLeft: 6, marginRight: 6, opacity: 0.3 }}>
                <FileCopyOutlinedIcon style={{ fontSize: 30 }} />
                <AddIcon
                  style={{
                    fontSize: 18,
                    position: 'absolute',
                    top: '60%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              </Box>
            </Tooltip>
          )}

          {/* Download CSV Button */}
          <Tooltip title="Download Categories CSV" arrow>
            <IconButton
              color="primary"
              size="medium"
              onClick={this.exportToCSV}
              style={{ marginLeft: 4 }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>

        { viewMode === null ? (
          <BrandedLoading />
        ) : isLoading ? (
          <BrandedLoading />
        ) : list.length === 0 ? (
          <SectionPaper>
             <EmptyMessage message={"You have not added any categories yet."} />
          </SectionPaper>
        ) : viewMode === 'grid' ?(
          <div className={classes.root}>
            <Grid container spacing={3}>
              {list.map(({ _id, image, name, isPublished, updatedAt, modifiedBy }) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={_id} sx={{ display: 'flex' }}>
                  <Card
                    sx={{
                      width: '100%',
                      maxWidth: 400,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      cursor: permissions.canEdit ? 'pointer' : 'default',
                    }}
                    onClick={() => permissions.canEdit && this.props.history.push(`/category/edit/${_id}`)}
                  >
                    <CardMedia
                      component="img"
                      image={getImageSource(image, updatedAt)}
                      loading="lazy"
                      onError={(e) => { 
                        e.target.src = getImageSource();  
                        e.target.style.maxHeight = '160px';
                        e.target.style.objectFit = 'contain';
                      }}
                      style={{
                        width: '100%',
                        height: '160px',
                        objectFit: 'cover',
                        flexShrink: 0,
                      }}
                      alt={name}
                    />
                    <CardContent sx={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', pb: 1 }}>
                      <Typography
                        variant="h6"
                        component="div"
                        title={name}
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          minHeight: '3.2rem',
                          lineHeight: 1.25,
                          fontSize: '1.1rem',
                        }}
                      >
                        {name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Updated: {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}
                        {modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ mt: 'auto' }}>
                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          onClick={(e) => { e.stopPropagation(); this.onDelete(_id); }}
                          disabled={!permissions.canDelete}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onClick={(e) => e.stopPropagation()}
                            checked={isPublished}
                            onChange={(e) => permissions.canEdit && this.onPublishToggle(e, _id)}
                            disabled={!permissions.canEdit}
                          />
                        }
                        label="Published"
                      />
                       <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={(e) => e.stopPropagation()}
                        component={Link}
                        to={routes.categoryManage.path(_id)}
                      >
                        Manage
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        ): (
          <SectionPaper>
            <Table padding={"normal"}>
              <TableHead>
                <TableRow>
                  <TableCell width={85}>Image</TableCell>
                  <TableCell width={200}>Name</TableCell>
                  <TableCell width={200} align="center">
                    Subcategories
                  </TableCell>
                  <TableCell width={180}>Updated</TableCell>
                  <TableCell width={80} align="center">
                    Published
                  </TableCell>
                  <TableCell width={180} align="center">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {list.map(({ _id, image, name, isPublished, updatedAt, modifiedBy }) => (
                  <TableRow key={_id} onClick={() => {if (permissions.canEdit) { this.props.history.push(`/category/edit/${_id}`) }}} style={{ cursor: 'pointer' }} hover>
                    <TableCell>
                      <Image
                        src={getImageSource(`${image}`, updatedAt)}
                        defaultSrc={getImageSource()}
                      />
                    </TableCell>
                    <TableCell>{name}</TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={(e) => e.stopPropagation()}
                        component={Link}
                        variant="outlined"
                        color="secondary"
                        to={routes.categoryManage.path(_id)}
                        style={{ borderRadius: '5px',
                        textTransform: 'none',  
                        padding: '1px 15px',     
                        fontSize: '0.8rem', 
                        }}
                      >
                        Manage
                      </Button>
                    </TableCell>
                    <TableCell>
                     {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}{modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox
                        onClick={(e) => e.stopPropagation()}
                        checked={isPublished}
                        onChange={(event) => permissions.canEdit && this.onPublishToggle(event, _id)}
                        color="primary"
                        disabled={!permissions.canEdit}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Delete" arrow>
                        <Button color="error" onClick={(e) => { e.stopPropagation(); this.onDelete(_id); }} disabled={!permissions.canDelete}><DeleteIcon /></Button>
                      </Tooltip>
                    </TableCell> 
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </SectionPaper>
        )
        }

      </div>
    );
  }
}

// Component Properties
List.propTypes = {
  categoriesParent: PropTypes.object.isRequired,
  listParent: PropTypes.func.isRequired,
  categoryCollection: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  publishToggle: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  detail: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

// Component State
function listState(state) {
  return {
    categoriesParent: state.categoriesParent,
  };
}

export default connect(listState, {
  listParent,
  categoryCollection,
  remove,
  publishToggle,
  messageShow,
  detail
})(withStyles(styles)(List));

